// extracted by mini-css-extract-plugin
export default {"avatar":"Settings_avatar__qx65Q","social_links":"Settings_social_links__dWQNN","cover":"Settings_cover__GkK9E","error_msg":"Settings_error_msg__t5QuY"};